import commandHeadingWidget from "../widgets/commandHeadingWidget.js";
import commandWidgetBuilderVisitor from "../command_visitors/commandWidgetBuilderVisitor.js";
import getNamedCommandHeading from "../../../models/accounting/document/getNamedCommandHeading.js";

/**
 * I am used to order and group the commands provided according to the
 * current selection into a structure that will be used to build the
 * command widgets in a polymorphic way.
 */

function commandWidgetsBuilder() {
	const that = {};

	const builder = commandWidgetBuilderVisitor();

	that.build = function (commands) {
		const map = collectHeadings(commands);
		const headings = sortHeadings(map);

		return buildSubCommandWidgets(headings, map);
	};

	function buildCommandWidgetsOn(commands) {
		const result = [];
		while (commands.length !== 0) {
			result.push(buildNextCommandWidgetFrom(commands));
		}
		return result;
	}

	function buildNextCommandWidgetFrom(remainingCommands) {
		const first = remainingCommands[0];
		// We remove the head from the remainingCommands
		// since it will be built
		remainingCommands.splice(0, 1);
		return builder.visit(first);
	}

	function collectHeadings(commands) {
		const map = {};

		commands.forEach((command) => {
			const heading = command.heading();
			if (map[heading.getName()] === undefined) {
				map[heading.getName()] = [];
			}
			map[heading.getName()].push(command);
		});

		return map;
	}

	function sortHeadings(map) {
		return Object.keys(map).sort(
			(a, b) =>
				getNamedCommandHeading(a).priority() -
				getNamedCommandHeading(b).priority(),
		);
	}

	function buildSubCommandWidgets(keys, map) {
		const widgets = [];

		keys.forEach((head) => {
			const subCommands = map[head];

			subCommands.sort(
				(commandA, commandB) =>
					commandA.priority() - commandB.priority(),
			);

			widgets.push(
				commandHeadingWidget({
					name: getNamedCommandHeading(head).getTranslation(),
					commandWidgets: buildCommandWidgetsOn(subCommands),
				}),
			);
		});

		return widgets;
	}

	return that;
}

export default commandWidgetsBuilder();
